import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import { FC } from 'react';

export const GpsrWarningBanner: FC<{ warning: string }> = ({ warning }) => {
	return (
		<Toolbar
			disableGutters
			sx={{
				backgroundColor: '#de000024',
				color: '#000000d0',
				fontStyle: 'italic',
				padding: '5px 5px 5px 15px',
				mt: -2,
				mb: 1,
				zIndex: 1000,
				'@media (min-width: 600px)': {
					minHeight: '56px',
				},
			}}
		>
			<span>
				<b>{warning}</b>
			</span>
		</Toolbar>
	);
};
